/** @format */
import React, { FC, useState } from 'react'
import { _$, Card } from '@king-design/react'
import TacticsList from 'src/containers/MonitorHistoryTactics/TacticsList'
import { CustomPageContainer, MonitorSearch, QuickRangeDate } from 'src/components'
import { DateTimeProps } from 'src/components/QuickRangeDate'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { useParams } from 'react-router'

interface OwnProps {
  className?: string
}

const TacticsDetail: FC<OwnProps> = ({ className }) => {
  const params = useParams<{ policyId: string; policyName: string }>()
  const [searchVal, setSearchVal] = useState('')
  const [dateTime, setDateTime] = useState<DateTimeProps>({
    StartTime: dayjs().subtract(1, 'h').unix(),
    EndTime: dayjs().unix()
  })
  return (
    <div className={className}>
      <CustomPageContainer showBack title={decodeURIComponent(params.policyName)}>
        <Card>
          <div className="search-content">
            <QuickRangeDate
              format="YYYY-MM-DD HH:mm"
              // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
              defautlValue={'近1小时'}
              // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
              quickRange={['近1小时', '近1天', '近3天', '近1周']}
              optionalDateRange={30}
              changeValue={date => {
                setDateTime({
                  StartTime: dayjs(date[0]).unix(),
                  EndTime: dayjs(date[1]).unix()
                })
              }}
            />
            <MonitorSearch
              placeholder={_$('输入实例ID')}
              onChange={search => setSearchVal(search)}
            />
          </div>
          <TacticsList
            region="all"
            queryType="InstanceId"
            dateTime={[dateTime.StartTime, dateTime.EndTime]}
            query={searchVal}
            policyName={decodeURIComponent(params?.policyName)}
            policyId={decodeURIComponent(params?.policyId)}
          />
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(TacticsDetail)`
  .search-content {
    display: flex;
    justify-content: space-between;
  }
`
